import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M3.5 4.5h2l1.7 10.7c.1.8.8 1.3 1.6 1.3h8.7c.7 0 1.3-.5 1.5-1.2L20.3 8H6"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "9",
      cy: "20",
      r: "1",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "17.5",
      cy: "20",
      r: "1",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "cart"}) } }